<script>
export default {
  name: 'TextareaField',
  props: {
    label: {
      type: String,
      required: true
    },
    modelValue: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: 'Enter value...'
    },
    required: {
      type: Boolean,
      default: true
    },
    validation: {
      type: Object,
      required: false
    }
  },
}
</script>

<template>
  <div>
    <label
        :for="label"
        class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
    >
      {{ label }}
    </label>
    <textarea
        :id="label"
        :value="modelValue"
        rows="4"
        class="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500"
        :placeholder="placeholder"
        @input="$emit('update:modelValue', $event.target.value)"
    ></textarea>
  </div>
</template>

<style scoped>

</style>